module.exports = __webpack_public_path__ + "img/thumbnail_Alpaca_m_piebald.d6ad0f56.png";